import { render, staticRenderFns } from "./TableTurnosC.vue?vue&type=template&id=64906297"
import script from "./TableTurnosC.vue?vue&type=script&lang=js"
export * from "./TableTurnosC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports